import { useDisclosure } from "@/hooks";
import { useCreateMeditationRetreat } from "@/hooks/query-hooks/useMeditationRetreats";
import { Button, Form, Modal } from "antd";
import { AiOutlinePlus } from "react-icons/ai";
import { MeditationRetreatForm } from "./MeditationRetreatForm";

export function AddNewMeditationRetreat() {

    const [opened, { toggle }] = useDisclosure();
    const [form] = Form.useForm();

    const { mutate, isLoading } = useCreateMeditationRetreat();
    const onSubmit = (data: CreateMeditationRetreatRequest) => {
        mutate(data, {
            onSuccess: () => {
                onToggleModal();
            }
        });
    }

    const onToggleModal = () => {
        form.resetFields();
        toggle();
    }

    return (
        <>
            <Button
                icon={<AiOutlinePlus />}
                onClick={onToggleModal}
                type="primary"
                shape="circle"
                size="large"
                className="bg-primary-gradient"
            />
            <Modal
                title="တရားစခန်းအသစ်"
                open={opened}
                onCancel={onToggleModal}
                okText="အတည်ပြုမည်"
                cancelText="ပယ်ဖျက်မည်"
                okButtonProps={{
                    form: "add-new-meditation-retreat",
                    htmlType: "submit",
                    type: "primary",
                    size: "large",
                    className: "bg-primary-gradient",
                    shape: "round",
                    loading: isLoading,
                }}
                cancelButtonProps={{
                    type: "text",
                    size: "large",
                    style: {
                        background: "transparent",
                    },
                    disabled: isLoading,
                }}
                width={640}
                maskClosable={!isLoading}
            >
                <MeditationRetreatForm
                    form={form}
                    onSubmit={onSubmit}
                    name="add-new-meditation-retreat"
                />
            </Modal>
        </>
    )
}
